import gql from 'graphql-tag';
import { editorBlockFragment } from '@/editor/api/graphql/editor-block.fragment';

export class DocumentMutations {
  static publishDocumentMutation = gql`
    mutation publishDocument($documentId: String!, $message: String!) {
      publishDocument(documentId: $documentId, message: $message)
    }
  `;

  static discardChangesMutation = gql`
    mutation discardChanges($documentId: String!) {
      discardChanges(documentId: $documentId)
    }
  `;

  static addDocumentPageMutation = gql`
    mutation AddDocumentPage(
      $documentId: String!
      $pageNum: Int!
      $videoId: String
      $blockId: String
      $pageType: DocumentPageType
    ) {
      addDocumentPage(
        documentPageInput: {
          documentId: $documentId
          pageNum: $pageNum
          videoId: $videoId
          blockId: $blockId
          pageType: $pageType
        }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        video {
          id
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
    }
    ${editorBlockFragment}
  `;

  static deleteDocumentPageMutation = gql`
    mutation DeleteDocumentPage($documentId: String!, $documentPageId: String!) {
      deleteDocumentPage(documentId: $documentId, documentPageId: $documentPageId)
    }
  `;

  static implementTemplateInDocumentMutation = gql`
    mutation ImplementTemplateInDocument(
      $documentId: String!
      $templateId: String!
      $pageOffset: Int!
    ) {
      implementTemplateInDocument(
        documentId: $documentId
        templateId: $templateId
        pageOffset: $pageOffset
      ) {
        id
        name
        status
        isSigning
        isSigningOrder
        isSelfsign
        type
        tags {
          title
          status
          id
        }
        value
        contractStartDate
        contractEndDate
        expirationDate
        isSigningBiometric
        isSigningInitials
        isSigningForward
        isPrivate
        previewUrl
        externalEditorId
        externalEditorType
        hasWriteAccess
        autoCommentText
        autoCommentEmail
        status
        user {
          email
          firstName
          lastName
          fullName
          id
          thumbUrl
        }
        recipients {
          firstName
          lastName
          fullName
          companyName
          companyNumber
          title
          mobile
          email
          thumbUrl
          gender
          role
          roleName
          id
          orderNum
          verifyEid
          verifyLinkedin
          verifyQna
          verifySms
        }
        pages {
          id
          thumbUrl
          pageType
          pageNum
          pageHeight
          pageWidth
          cropBoxH
          cropBoxW
          video {
            id
            thumbUrl
            videoUrl
          }
          contentLinkBlock {
            buttonText
            description
            id
            thumbUrl
            thumbExtension
            title
            url
          }
          editorBlock {
            ...editorBlockFragment
          }
        }
        video {
          video {
            id
            thumbUrl
            videoUrl
            videoType
          }
        }
        documentAttachments {
          id
          restrictAccess
          requireView
          createdAt
          previewUrl
          attachment {
            attachmentType
            attachmentTitle
            attachmentDescription
            attachmentUrl
            attachmentFilename
            attachmentSize
            attachmentSha
            thumbUrl
            published
            library
            hashId
          }
          accessRecipientList {
            id
            firstName
            lastName
            fullName
            roleName
          }
        }
      }
    }
    ${editorBlockFragment}
  `;

  static sortDocumentPagesMutation = gql`
    mutation SortDocumentPages(
      $documentId: String!
      $documentPageIds: [String!]!
      $pageNums: [Int!]!
    ) {
      sortDocumentPages(
        payload: { documentId: $documentId, documentPageIds: $documentPageIds, pageNums: $pageNums }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
      }
    }
  `;

  static sealDocumentMutation = gql`
    mutation SealDocument($documentId: String!, $sendDocument: Boolean!) {
      sealDocument(documentId: $documentId, sendDocument: $sendDocument)
    }
  `;

  static updateSignatureMutation = gql`
    mutation UpdateSignature($signature: String!) {
      updateSignature(signature: $signature)
    }
  `;
  static updateDocumentMutation = gql`
    mutation updateDocument(
      $documentId: String!
      $name: String
      $contractStartDate: String
      $contractEndDate: String
      $value: Int
      $expirationDate: String
      $isSigningInitials: Int
      $isSigningBiometric: Int
      $isSigningForward: Int
      $isPrivate: Int
      $isSigning: Int
      $isSelfsign: Int
      $isSigningOrder: Int
      $type: DocumentType
      $userId: String
      $isSmsReminder: Int
      $isReminderSending: Int
      $reminderOpened: Int
      $reminderOpenedDays: Int
      $reminderSigned: Int
      $reminderSignedDays: Int
      $reminderRepeatDays: Int
      $reminderExpiration: Float
      $reminderExpirationDays: Int
      $isAutoComment: Int
      $isAutoCommentEmail: Int
      $isIdentifyRecipient: Int
      $autoCommentText: String
      $autoCommentEmail: String
    ) {
      updateDocument(
        documentId: $documentId
        name: $name
        contractStartDate: $contractStartDate
        contractEndDate: $contractEndDate
        value: $value
        expirationDate: $expirationDate
        isSigningInitials: $isSigningInitials
        isSigningBiometric: $isSigningBiometric
        isSigningForward: $isSigningForward
        isPrivate: $isPrivate
        isSigning: $isSigning
        isSelfsign: $isSelfsign
        isSigningOrder: $isSigningOrder
        type: $type
        userId: $userId
        isSmsReminder: $isSmsReminder
        isReminderSending: $isReminderSending
        reminderOpened: $reminderOpened
        reminderOpenedDays: $reminderOpenedDays
        reminderSigned: $reminderSigned
        reminderSignedDays: $reminderSignedDays
        reminderRepeatDays: $reminderRepeatDays
        reminderExpiration: $reminderExpiration
        reminderExpirationDays: $reminderExpirationDays
        isAutoComment: $isAutoComment
        isAutoCommentEmail: $isAutoCommentEmail
        isIdentifyRecipient: $isIdentifyRecipient
        autoCommentText: $autoCommentText
        autoCommentEmail: $autoCommentEmail
      ) {
        id
      }
    }
  `;

  static deleteDocumentsMutation = gql`
    mutation DeleteDocuments($ids: [String!]!) {
      deleteDocuments(ids: $ids) {
        id
      }
    }
  `;

  static updateDocumentPageMutation = gql`
    mutation UpdateDocumentPage(
      $id: String!
      $pageType: DocumentPageType
      $videoId: String
      $blockId: String
    ) {
      updateDocumentPage(
        documentPage: { id: $id, videoId: $videoId, blockId: $blockId, pageType: $pageType }
      ) {
        id
        thumbUrl
        pageType
        pageNum
        pageHeight
        pageWidth
        cropBoxH
        cropBoxW
        video {
          id
          thumbUrl
          videoUrl
          videoTitle
        }
        contentLinkBlock {
          buttonText
          description
          id
          thumbUrl
          thumbExtension
          title
          url
        }
        editorBlock {
          ...editorBlockFragment
        }
      }
    }
    ${editorBlockFragment}
  `;

  static sendEmailReminderMutation = gql`
    mutation sendEmailReminder(
      $documentId: String!
      $isNotSignedSelected: Boolean!
      $isNotOpenedSelected: Boolean!
    ) {
      sendEmailReminder(
        documentId: $documentId
        payload: {
          isNotSignedSelected: $isNotSignedSelected
          isNotOpenedSelected: $isNotOpenedSelected
        }
      )
    }
  `;

  static sendSMSReminderMutation = gql`
    mutation sendSMSReminder(
      $documentId: String!
      $message: String!
      $isNotSignedSelected: Boolean!
      $isNotOpenedSelected: Boolean!
    ) {
      sendSMSReminder(
        documentId: $documentId
        payload: {
          message: $message
          isNotSignedSelected: $isNotSignedSelected
          isNotOpenedSelected: $isNotOpenedSelected
        }
      )
    }
  `;

  static documentUpdatedMutation = gql`
    mutation DocumentUpdated($documentId: String!) {
      documentUpdated(documentId: $documentId)
    }
  `;
}
